import { useCallback } from "react";
import { useAppSelector } from "../../../common/state/hooks";
import { routeNeedsUnloadedEntity } from "../state/onboardingSlice";

export const useRouteNeedsUnloadedEntity = (): ((route: string) => boolean) => {
  const loadedCourseId = useAppSelector((state) => state.projectGroups.current?.id);
  const loadedProjectId = useAppSelector((state) => state.projects.currentProject?.id);
  return useCallback(
    (route: string) =>
      routeNeedsUnloadedEntity(route, {
        projectGroups: { current: { id: loadedCourseId } },
        projects: { currentProject: { id: loadedProjectId } },
      }),
    [loadedCourseId, loadedProjectId],
  );
};

export default useRouteNeedsUnloadedEntity;
